import React from 'react';
import { Box, keyframes, styled } from '@mui/material';

// Define the animations
const rotateAnimation = keyframes`
  0% { transform: rotate3d(0.5, 1, 0.5, 0deg); }
  50% { transform: rotate3d(0.5, 1, 0.5, 180deg); }
  100% { transform: rotate3d(0.5, 1, 0.5, 360deg); }
`;

const fadeInAnimation = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

// Styled components for the loader
const LoaderContainer = styled(Box)(({ theme, overlay }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  width: '100%',
  position: overlay ? 'fixed' : 'relative',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
  backgroundColor: overlay ? 'rgba(0, 0, 0, 0.7)' : 'transparent',
  animation: `${fadeInAnimation} 0.3s ease-in-out`,
}));

const CubeIcon = styled('svg')(({ theme }) => ({
  width: '150px',
  height: '150px',
  animation: `${rotateAnimation} 8s infinite linear`,
  filter: 'drop-shadow(0 0 15px rgba(0, 124, 63, 0.6))',
  strokeLinejoin: 'round',
  strokeLinecap: 'round',
}));

const Loading = ({ overlay = false }) => {
  return (
    <LoaderContainer overlay={overlay}>
      <CubeIcon viewBox="0 0 400 400" fill="none" stroke="#007C3F" strokeWidth="6">
        {/* Cube design exactly matching the provided image */}
        {/* Top layer */}
        <path d="M200 80L120 120L200 160L280 120L200 80Z" />
        <path d="M120 120L120 200L200 240L200 160L120 120Z" />
        <path d="M200 160L200 240L280 200L280 120L200 160Z" />
        
        {/* Middle layer */}
        <path d="M160 160L80 200L160 240L240 200L160 160Z" />
        <path d="M80 200L80 280L160 320L160 240L80 200Z" />
        <path d="M160 240L160 320L240 280L240 200L160 240Z" />
        
        {/* Bottom layer */}
        <path d="M240 200L320 240L240 280L160 240L240 200Z" />
        <path d="M320 240L320 320L240 360L240 280L320 240Z" />
        <path d="M240 280L240 360L160 320L160 240L240 280Z" />
      </CubeIcon>
    </LoaderContainer>
  );
};

// Export a standalone loader that can be used anywhere in the app
export const AppLoader = () => {
  return <Loading overlay={true} />;
};

export default Loading;